import  { useContext, useEffect, useRef, useState } from "react";
import { AddedSongs, BhagavatamCotent, BookMark, BookmarkSpos, Colour, FontType, Hindit, IskconContent } from "../global";
import { IonItem, IonButton, IonLabel, IonToolbar, IonButtons, IonCheckbox, IonSegment, IonSegmentButton, IonPage, IonHeader, IonContent, IonFooter, isPlatform } from "@ionic/react";
import { IndeterminateCheckBoxOutlined, MoreVertSharp } from "@mui/icons-material";
import { QueueMusicSharp, MenuBookSharp } from "@mui/icons-material";
import { Switch, Route, useLocation, useRouteMatch, useHistory } from "react-router-dom";
import Bsub from "./bsub";
import { AutoStoriesSharp, PlayLessonSharp } from "@mui/icons-material";
import SP from "../../sp.svg";
import { useLocal } from "../lshooks";

function Bookmarks() {
 let { path, url } = useRouteMatch();
 const [bookMark, dispatch] = useContext(BookMark);
 const [select, setSelect] = useState(false);
 let history = useHistory();
 let location = useLocation();
 const [iskcon, ] = useContext(IskconContent);
 const[singersMap, setSingersMap] = useState({})
 const[englishToHindi, setEnglishToHindi] = useState({})
 const [addedSongs, ] = useContext(AddedSongs)
 const contentRef = useRef();
 const [spos, setSpos] = useContext(BookmarkSpos);
 const [content2, ] = useContext(BhagavatamCotent)
 let locy = 0;

 const customEnglishSort = (a, b) => {
  const order = ["HDG", "HH", "HG", "Vaishnavas"];

  const getPriority = (key) => {
    for (let prefix of order) {
      if (key.startsWith(prefix)) {
        return order.indexOf(prefix);
      }
    }
    return order.length; // If not found in order, place it at the end
  };

  const priorityA = getPriority(a);
  const priorityB = getPriority(b);

  if (priorityA !== priorityB) {
    return priorityA - priorityB; // Sort by priority
  }

  // If priorities are the same, sort lexicographically
  return a.localeCompare(b);
};



useEffect(() => {
  if (location.pathname === url && contentRef.current){
    contentRef.current.scrollToPoint(0,spos);
  } 
}, [location, contentRef.current]);

 useEffect(()=>{
  let singersMap = {}
  let englishToHindi = {}
  for (let song of iskcon.songs){
    for(let singer of song.link) {
      let singerName = singer.linkname.slice(0, (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) === -1 ? singer.linkname.length : (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) )
      if(singerName === "Srila Prabhupada") singerName = "HDG Srila Prabhupada"
      if(!singersMap[singerName]) singersMap[singerName]=[]
      singersMap[singerName].push({"name": song.name, "path": "/home/songs/"+song.name+"_"+ (song.book ?? "") })
      let hsingerName = singer.hlinkname.slice(0, (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")) === -1 ?  singer.hlinkname.length : (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")))
      englishToHindi[singerName] = hsingerName
    }
  }
  for (const [i, chap] of content2.chap.entries()) {
    for (const [j, song] of chap.song.entries()) {
      for(let singer of (song.link ?? [])) {
        let singerName = singer.linkname.slice(0, (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) === -1 ? singer.linkname.length : (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) )
        if(singerName === "Srila Prabhupada") singerName = "HDG Srila Prabhupada"
        if(!singersMap[singerName]) singersMap[singerName]=[]
        singersMap[singerName].push({"name": song.name.slice(3), "path": `/sb/${i}_${j}` })
        let hsingerName = singer.hlinkname.slice(0, (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")) === -1 ?  singer.hlinkname.length : (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")))
        englishToHindi[singerName] = hsingerName
      }
    }
  }
  for (let songName of Object.keys(addedSongs)) {
    for (let singer of addedSongs[songName]) {
      let singerName = singer.singer.slice(0, (singer.singer.indexOf(" (") !== -1 ? singer.singer.indexOf(" (") : singer.singer.indexOf("(")) === -1 ? singer.singer.length : (singer.singer.indexOf(" (") !== -1 ? singer.singer.indexOf(" (") : singer.singer.indexOf("(")) )
      if(!singersMap[singerName]) singersMap[singerName] = []
      singersMap[singerName].push({"name": songName, "path": singer.link})
    }
  }

  const sortedEnglishKeys = Object.keys(singersMap).sort(customEnglishSort);

  const sortedEnglishObject = {};
  sortedEnglishKeys.forEach((key) => {
    sortedEnglishObject[key] = singersMap[key];
  });

 setSingersMap({...sortedEnglishObject})
 setEnglishToHindi({...englishToHindi})
 },[])

 const [clr, ] = useContext(Colour);
 let colori,colorh,colorsp,color4;
 if(clr === "1") {
  colori = ""
  colorh = "primary"
  colorsp = "#3880ff"
  color4 = "black"
 }
 if(clr === "2") {
  colori = "secondary"
  colorh = "warning"
  colorsp = "#F5CA16"
  color4 = "black"
 }
 if(clr === "3") {
  colori = "secondary"
  colorh = "success"
  colorsp = "#FF9933"
  color4 = "black"
 }
 if(clr === "4") {
  colori = "secondary"
  colorh = "tertiary"
  colorsp = "#6FB1FC"
  color4 = "black"
 }
 if(clr === "5") {
  colori = "dark"
  colorh = "warning"
  colorsp = "#F5CA16"
  color4 = "white"
 }
 if(clr === "6") {
  colori = "dark"
  colorh = "tertiary"
  colorsp = "#6FB1FC"
  color4 = "white"
 }

 const [font, ] = useContext(FontType);
 const [hindit, ] = useContext(Hindit);
 const [listType, setListType] = useLocal("bookmarks-type","bookmarks")

 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";



 return (
  <div>
   <Switch location={location}>
    <Route exact path={path}>
     <IonPage>

       <IonHeader mode="ios">
       <IonToolbar color={colorh}>
       {listType==="bookmarks" && !select ? (
        <IonButtons
         slot="start"
         style={{visibility:"hidden"}} 
        >
         <IonButton>
          <IndeterminateCheckBoxOutlined />
         </IonButton>
        </IonButtons>
       ) : (
        <p></p>
       )}
      {!select ? (
       <IonSegment mode="ios" color={"dark"} onIonChange={(e)=>{
            setListType(e.detail.value)
          }} value={listType}>
        <IonSegmentButton value="bookmarks">
          <IonLabel>{hindit ?"लिस्ट्स": "Lists"}</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value="singers">
          <IonLabel>{hindit ? "गायक": "Singers"}</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value="history">
          <IonLabel>{hindit ? "हिस्ट्री": "History"}</IonLabel>
        </IonSegmentButton>
      </IonSegment>
       ) : (
        <p></p>
       )}

      {listType==="bookmarks" && select ? (
        <IonButtons
         style={{ margin: "0 8px" }}
         slot="end"
         onClick={() => {
          dispatch({ type: "delfold" });
         }}
        >
         <IonLabel style={{ fontFamily: `${fon}` }}>Remove</IonLabel>
        </IonButtons>
       ) : (
        <p></p>
       )}

       {listType==="bookmarks" && !select ? (
        <IonButtons
         onClick={() => {
          setSelect(true);
         }}
         slot="end"
        >
         <IonButton>
          <IndeterminateCheckBoxOutlined />
         </IonButton>
        </IonButtons>
       ) : (
        <p></p>
       )}

       {listType==="bookmarks" && select ? (
        <IonButtons
         style={{ margin: "0 8px" }}
         onClick={() => {
          bookMark.forEach((ele) => {
           ele.isChecked = false;
          });

          setSelect(false);
         }}
         slot="end"
        >
         <IonLabel style={{ fontFamily: `${fon}` }}>Close</IonLabel>
        </IonButtons>
       ) : (
        <p></p>
       )}
          </IonToolbar>
      </IonHeader>
      <IonContent onIonScroll={(e)=>{
        locy = e.detail.scrollTop;
      }} onIonScrollEnd = {()=>{setSpos(locy)}} ref={contentRef} scrollEvents={true} color={colori} >
      {listType==="bookmarks" ? <>
      {bookMark.length === 0 ? (
       <>
       {!hindit ?
        <p style={{ textAlign: "center", color: `${color4}`, fontFamily: `${fon}`, margin: "10px" }}>
          You can add a song to list by clicking <MoreVertSharp /> Icon on the heading toolbar of that song and then by clicking Bookmark/Playlist option
        </p> : <p style={{ textAlign: "center", color: `${color4}`, fontFamily: `${fon}`, margin: "10px" }}>
        आप गाने को लिस्ट में जोड़ सकते हैं, उस गाने के हेडिंग टूलबार पर <MoreVertSharp /> आइकन पर क्लिक करके और फिर बुकमार्क/प्लेलिस्ट ऑप्शन पर क्लिक करके।
        </p>}
       </>
      ) : null}
      {bookMark.map((ele, i) => {
       return (
        <IonItem key={i} button={isPlatform('desktop') ? true : false}          color={colori}
         onClick={() => {
          if (!select) history.push(`${url}/${i}`);
         }}
        >
        

         {select ? (
          <IonCheckbox
           style={{ fontFamily: `${fon}` }}
           checked={ele.isChecked}
           onIonChange={(e) => {
            ele.isChecked = e.detail.checked;
           }}
          >{ele.name ?? "Default"}</IonCheckbox>
         ) : (
          <IonLabel style={{ fontFamily: `${fon}` }}>{ele.name ?? "Default"} </IonLabel>
         )}
        </IonItem>
       );
      })}
    </> : null}

    {listType==="singers" ? <>
    {Object.keys(singersMap).map((key, i)=>{
      return(
      <IonItem key={i} button={isPlatform('desktop') ? true : false}          color={colori}
      onClick={() => {
       if (!select) history.push(`${url}/${key}`);
      }}
     >
      <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? (englishToHindi[key] ?? key) : key}</IonLabel>
     </IonItem>
      )
    })}
    </>: null}

    {listType==="history" ? <>
   
      <IonItem button={isPlatform('desktop') ? true : false}          color={colori}
      onClick={() => {
       if (!select) history.push(`${url}/addedsongs`);
      }}
     >
      <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "जोड़े गए ऑडियो" : "Added Audios"}</IonLabel>
     </IonItem>
     {!(isPlatform("desktop") || isPlatform("mobileweb")) ? <IonItem button={isPlatform('desktop') ? true : false}          color={colori}
      onClick={() => {
       if (!select) history.push(`${url}/downloadedsongs`);
      }}
     >
      <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "डाउनलोड किए गए ऑडियो" : "Downloaded Audios"}</IonLabel>
     </IonItem> : null}
     <IonItem button={isPlatform('desktop') ? true : false}          color={colori}
      onClick={() => {
       if (!select) history.push(`/history`);
      }}
     >
      <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "गानों का हिस्ट्री" : "Songs History"}</IonLabel>
     </IonItem>
    
    </>: null}



     </IonContent>




     <IonFooter>
       <IonToolbar mode="md" color={colorh}>
        <IonSegment value="default">
         <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/home")}>
          <QueueMusicSharp />
         </IonSegmentButton>
         {!hindit ? (
          <>
           <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/books")}>
            <MenuBookSharp />
           </IonSegmentButton>
           <IonSegmentButton  style={{ minWidth: 0 }} onClick={() => history.push("/sp")}>
            <img alt="SP" src={SP} style={{ height: "40px", backgroundColor: colorsp, borderRadius:"50%" }} />
           </IonSegmentButton>
           <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/sb")}>
            <AutoStoriesSharp />
           </IonSegmentButton>
          </>
         ) : <IonSegmentButton  style={{ minWidth: 0 }} onClick={() => history.push("/sp")}>
         <img alt="SP" src={SP} style={{ height: "40px", backgroundColor: colorsp, borderRadius:"50%" }} />
        </IonSegmentButton>}

         <IonSegmentButton value="default" style={{ minWidth: 0 }} onClick={() => history.push("/lists")}>
          <PlayLessonSharp />
         </IonSegmentButton>
        </IonSegment>
       </IonToolbar>
       </IonFooter>
     </IonPage>
    </Route>
    <Route path={`${path}/:ind`}>
     <Bsub />
    </Route>
   </Switch>
  </div>
 );
}

export default Bookmarks;
